import showToastNotification from '@/hooks/useShowToast'
import { trpc } from '@/utils/trpc'

export const useChangeTeamMemberRole = () => {
  const utils = trpc.useUtils()
  const { mutate: changeTeamMemberRole, isPending: isChangingMemberRole } = trpc.changeTeamMemberRole.useMutation({
    onSuccess: async () => {
      showToastNotification('success', {
        message: `Success`,
        description: `Role switched successfully!`,
      })
      await utils.getTeamMembers.invalidate()
    },
    onError: () => {
      showToastNotification('error', {
        message: `Failed Role Switch`,
        description: `Unfortunately, we couldn't change this user's role. Please try again later.`,
      })
    },
  })

  return { changeTeamMemberRole, isChangingMemberRole }
}
